import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { forwardRef, useState } from 'react';
import TextCTA from '../TextCTA/TextCTA.js';
import ModalOrBottomSheetWrapper from '../ModalOrBottomSheetWrapper/ModalOrBottomSheetWrapper.js';
import Typography from '../Typography/Typography.js';

const ShowMoreText = forwardRef((props, ref) => {
    const { text = "", onClick, id, less = "see less", more = "see more", truncatedEnding = "...", limit = 24, showPopUpView, preWrapPopUpText, renderPopUpBody, popUpProps, } = props;
    const [isExpanded, setIsExpanded] = useState(false);
    const [isPopUpOpen, setIsPopUpOpen] = useState(false);
    const togglePopUp = () => {
        setIsPopUpOpen((v) => !v);
    };
    const onToggle = () => {
        if (!!onClick) {
            onClick();
        }
        else if (showPopUpView) {
            setIsPopUpOpen(true);
        }
        else {
            setIsExpanded((v) => !v);
        }
    };
    const shouldTruncateString = (text === null || text === void 0 ? void 0 : text.length) > limit;
    const truncatedString = text
        .slice(0, limit)
        .split(" ")
        .slice(0, -1)
        .join(" ");
    const ExpandActionSlot = (jsxs(Fragment, { children: ["\u00A0", jsx(TextCTA, Object.assign({ onClick: onToggle, weight: "medium", underline: true }, { children: isExpanded ? less : more }))] }));
    return (jsxs(Fragment, { children: [shouldTruncateString ? (jsx(Fragment, { children: isExpanded ? (jsxs(Fragment, { children: [text, ExpandActionSlot] })) : (jsxs(Fragment, { children: [truncatedString, truncatedEnding, "\u00A0", ExpandActionSlot] })) })) : (jsxs(Fragment, { children: [text, (props === null || props === void 0 ? void 0 : props.actionAlwaysVisible) && ExpandActionSlot] })), jsx(ModalOrBottomSheetWrapper, Object.assign({ isOpen: isPopUpOpen, onToggle: togglePopUp, modalSeparationGap: 0 }, popUpProps, { children: renderPopUpBody ? (renderPopUpBody) : (jsx(Typography, Object.assign({ preWrap: preWrapPopUpText }, { children: text }))) }))] }));
});

export { ShowMoreText as default };
//# sourceMappingURL=ShowMoreText.js.map
